import { ca } from '@cian/analytics';

export const onEntryPointClick = ({ regionId }: { regionId: number | null }) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry',
    action: 'Click_sopr',
    label: 'Click',
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const onEntryAutorisationPopupOpen = ({
  customPageURL,
  regionId,
}: {
  customPageURL: string;
  regionId: number | null;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry_popup',
    action: 'Show_sopr',
    label: customPageURL,
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const onEntryAutorisationPopupClick = ({
  customPageURL,
  regionId,
}: {
  customPageURL: string;
  regionId: number | null;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat_kpn_entry_popup',
    action: 'Click_sopr',
    label: customPageURL,
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        region: regionId,
      },
    },
  });

export const onOpenChatPopup = ({
  customPageURL,
  chatId,
  botId,
  ownerId,
  regionId,
}: {
  customPageURL: string;
  chatId: string;
  botId: number;
  ownerId?: number;
  regionId: number | null;
}) =>
  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'open',
    label: customPageURL,
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        chat_id: chatId,
        bot_id: botId,
        owner_id: ownerId,
        region: regionId,
      },
    },
  });
